/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterUrlaubStatistikenDto } from '../../models/mitarbeiter-urlaub-statistiken-dto';

export interface GetUrlaubsStatistikenForMitarbeiter$Json$Params {

/**
 * ID des Mitarbeiter für den die Urlaubstatistiken geholt werden sollen
 */
  mitarbeiterId: string;

/**
 * Stichtag für die Urlaubsstatistiken geholt werden sollen
 */
  stichtag?: string;
}

export function getUrlaubsStatistikenForMitarbeiter$Json(http: HttpClient, rootUrl: string, params: GetUrlaubsStatistikenForMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterUrlaubStatistikenDto>> {
  const rb = new RequestBuilder(rootUrl, getUrlaubsStatistikenForMitarbeiter$Json.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.query('stichtag', params.stichtag, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterUrlaubStatistikenDto>;
    })
  );
}

getUrlaubsStatistikenForMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}/urlaubsstatistiken';
